import { render, staticRenderFns } from "./explain-form.html?vue&type=template&id=5fc497d4&scoped=true&external"
import script from "./explain-form.js?vue&type=script&lang=js&external"
export * from "./explain-form.js?vue&type=script&lang=js&external"
import style0 from "./explain-form.scss?vue&type=style&index=0&id=5fc497d4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc497d4",
  null
  
)

export default component.exports